var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc tooltip helper
 */
import { Rect, Text, Circle } from '../../element';
import { getPadding } from '../../utils/styleHelper';
import * as lodash from '../../utils/lodash';
import measureText from '../../utils/measureText';
import { createRichText } from '../../rich';
export function renderCanvasTooltip(param, tooltipModel) {
    var group = tooltipModel.group, option = tooltipModel.option;
    group.clear();
    var padding = option.padding, borderRadius = option.borderRadius, borderColor = option.borderColor, borderWidth = option.borderWidth, backgroundColor = option.backgroundColor, fontSize = option.textStyle.fontSize, rtl = option.rtl, nameFormatter = option.nameFormatter, valueFormatter = option.valueFormatter, titleFormatter = option.titleFormatter, formatter = option.formatter, 
    // shadow,
    minWidth = option.minWidth;
    var _a = getPadding(padding), paddingTop = _a.paddingTop, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom;
    if (typeof formatter === 'function') {
        var content = formatter(param);
        var tooltipPadding = [paddingTop, paddingRight, paddingBottom, paddingLeft];
        var text = void 0;
        if (content && content.type) {
            text = {
                type: 'vbox',
                padding: tooltipPadding,
                borderRadius: borderRadius,
                borderWidth: borderWidth,
                borderColor: borderColor,
                background: backgroundColor,
                children: [content],
            };
        }
        else {
            text = "<vbox \n      padding=\"" + tooltipPadding.join(' ') + "\" \n      borderRadius=\"" + borderRadius + "\" \n      borderWidth=\"" + borderWidth + "\" \n      borderColor=\"" + borderColor + "\" \n      background=\"" + backgroundColor + "\"\n  >" + content + "</vbox>";
        }
        return group.add(createRichText(__assign({ text: text, rich: true, x: 0, y: 0 }, tooltipModel.getTextStyle(option.textStyle))));
    }
    var titleMargin = 12;
    var _b = param.title, titleText = _b === void 0 ? '' : _b, points = param.points;
    var title = titleFormatter(titleText, param);
    var titleWidth = measureText(title, option.textStyle).width;
    var titleHeight = title ? fontSize : 0;
    var rowBottom = title ? paddingTop + titleHeight + titleMargin : paddingTop;
    var nameGap = 36;
    var iconSize = 6;
    var iconMargin = 8;
    var tooltipHeight = points.length * (fontSize + 12) +
        (title ? titleHeight + titleMargin : 0) +
        paddingTop +
        paddingBottom -
        12;
    var rowWidthList = [titleWidth];
    var bgRect = new Rect({
        key: 'tooltip-background',
    });
    group.add(bgRect);
    var itemList = [];
    points.forEach(function (point, dataIndex) {
        var label = nameFormatter(point);
        var value = valueFormatter(point);
        var nameWidth = measureText(label, option.textStyle).width;
        var valueWidth = measureText("" + value, option.textStyle).width;
        rowWidthList.push(iconSize + iconMargin + nameWidth + nameGap + valueWidth);
        var rowCenter = rowBottom + fontSize / 2;
        var circle = new Circle({
            key: "tooltip-icon" + dataIndex,
            cx: paddingLeft + iconSize / 2,
            cy: rowCenter,
            radius: iconSize / 2,
            fill: point.color,
        });
        var nameText = new Text(__assign(__assign({ key: "tooltip-name" + dataIndex, x: paddingLeft + iconSize + iconMargin, y: rowCenter, text: label }, tooltipModel.getTextStyle(option.textStyle)), { textBaseline: 'middle' }));
        var valueText = new Text(__assign(__assign({ key: "tooltip-value" + dataIndex, x: paddingLeft + iconSize + iconMargin + nameWidth + nameGap, y: rowCenter, text: value + '' }, tooltipModel.getTextStyle(option.textStyle)), { textAlign: 'left', textBaseline: 'middle' }));
        group.add(circle);
        group.add(nameText);
        group.add(valueText);
        itemList.push([circle, nameText, valueText]);
        rowBottom += fontSize + 12;
    });
    var maxRowWidth = lodash.max(rowWidthList);
    if (minWidth > 0 && maxRowWidth < minWidth + paddingLeft + paddingRight) {
        maxRowWidth = minWidth;
    }
    var maxWidth = maxRowWidth + paddingLeft + paddingRight;
    if (title) {
        group.add(new Text(__assign(__assign({ key: 'tooltip-title', x: rtl ? maxRowWidth + paddingLeft : paddingLeft, textAlign: rtl ? 'end' : 'start', y: paddingTop, text: title }, tooltipModel.getTextStyle(option.textStyle)), { fontWeight: 'bold', textBaseline: 'top' })));
    }
    itemList.forEach(function (item) {
        var circle = item[0], nameText = item[1], valueText = item[2];
        if (rtl) {
            circle.setAttr({
                cx: maxRowWidth + paddingLeft - iconSize / 2,
            });
            nameText.setAttr({
                x: maxRowWidth + paddingLeft - iconSize - iconMargin,
                textAlign: 'end',
            });
            valueText.setAttr({
                x: paddingLeft,
                textAlign: 'start',
            });
        }
        else {
            valueText.setAttr({
                x: maxRowWidth + paddingLeft,
                textAlign: 'end',
            });
        }
    });
    bgRect.setAttr({
        x: 0,
        y: 0,
        width: maxWidth,
        height: tooltipHeight,
        fill: option.backgroundColor,
        stroke: option.borderColor,
        lineWidth: option.borderWidth,
        r: option.borderRadius,
    });
    return group;
}
